/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientOut
 */
export interface ClientOut {
    /**
     * 
     * @type {string}
     * @memberof ClientOut
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ClientOut
     */
    clientId: number;
    /**
     * 
     * @type {Date}
     * @memberof ClientOut
     */
    modificationDate: Date;
}

export function ClientOutFromJSON(json: any): ClientOut {
    return ClientOutFromJSONTyped(json, false);
}

export function ClientOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'clientId': json['clientId'],
        'modificationDate': (new Date(json['modificationDate'])),
    };
}

export function ClientOutToJSON(value?: ClientOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'clientId': value.clientId,
        'modificationDate': (value.modificationDate.toISOString()),
    };
}


